<template>
  <div>
    <andes-header></andes-header>
    <div class="container">

      <div class="row">
        <div class="col-sm-9">


          <!-- DETALLE DE BUSQUEDA ACTUAL  -->
          <div class="row">
            <div class="col-12">
              <div class="current-srch-container">
                <div class="row d-flex align-items-center text-center text-sm-left">
                  <div class="col-12 col-sm-6 ">
                    <h1>{{ $t('Itinerario') }}</h1>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="reservation text-center">{{ $t('Reserva:') }} {{ booking.RecordLocator }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="row">
            <div class="col-12 itin">

              <div v-show="hasPaymentError" class="mb-3 alert alert-danger" role="alert">
                {{ $t('Su pago fue aceptado pero no impacto en la reserva. Por favor comuniquese al 0810-777-2633.') }}
              </div>
              <payment-pending />
              <payment-summary class="mb-3"></payment-summary>


              <flight-summary :flight-type="i" class="mb-3" v-for="(segment,i) of booking.Passengers[0].Segments"
                              :flight="segment" :key="i"></flight-summary>
              <passenger-summary class="mb-3"
                  :flight="booking.Passengers[0].Segments[0]"
              ></passenger-summary>
              <div v-if="pendingChange" class="mb-3 alert alert-info" role="alert">
                {{ $t('Tenés un cambio de vuelo cotizado sin pagar. El cambio se aplica cuando se acredite el pago.') }}
              </div>
              <div v-if="failedChange" class="mb-3 alert alert-warning" role="alert">
                {{ $t('No pudimos aplicar tu cambio de vuelo:') }} {{ failedChange.Message }}
                {{ $t('Por favor comuniquese al 0810-777-2633.') }}
              </div>

              <div class="itin-ancillary-actions mb-3" v-if="!hasCharterFlight">
                <button type="button" class="btn btn-andes" :disabled="loading" @click="goAddExtras">
                  {{ $t('Editar extras') }}
                </button>
                <button type="button" class="btn btn-andes" :disabled="loading" @click="goBuySeat">
                  {{ $t('Elegir asiento') }}
                </button>
                <button type="button" class="btn btn-andes" v-if="canChangeFlight"
                        :disabled="loading" @click="goChangeFlight">
                  {{ $t('Modificar reserva') }}
                </button>
                <button type="button" class="btn btn-andes" v-if="canRequestRefund"
                        :disabled="loading" @click="goRefund">
                  {{ $t('Solicitar devolución') }}
                </button>
              </div>

              </div>
            </div>

          <div class="row" v-if="hasExtras">
            <div class="col-12 itin">
              <extras-list class="mb-3"></extras-list>
            </div>
          </div>

        </div>
        <!-- SIDEBAR  -->
        <div class="col-sm-3">
          <div class="row">
            <div class="col-12">
              <div class="manage-my-booking-container">
                <p class="checkin_message"><strong>{{ $t('Checkin Online se habilitará desde las 24 hs andes de la salida de su vuelo.') }}</strong></p>
              </div>

              <div class="manage-my-booking-container">
                <p class="checkin_message"><strong>{{ $t('IMPORTANTE:') }}</strong>
                  {{ $t('Por favor tenga a bien despachar en el mostrador de Andes cualquier equipaje que supere los 5 kg. El no hacerlo puede devenir en demoras y hasta pérdida del vuelo por parte del pasajero.') }}
                </p>
                <p class="checkin_message">
                  {{ $t('Las mujeres embarazadas podrán viajar sin restricción hasta la semana 20 de embarazo (5 meses). A partir de la semana 21 (5 meses) necesitan un certificado médico MEDIF emitido dentro de los 5 (cinco) días previos a la fecha de vuelo. Pasajeras con un embarazo igual o superior a las 32 semanas cumplidas (ocho meses) no podrán viajar.') }}
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <andes-footer/>
    <loading-modal v-if="loading"></loading-modal>
  </div>

</template>

<script>
  import {mapState} from 'vuex';
  import AndesHeader from "../components/AndesHeader";
  import LoadingModal from "../components/LoadingModal"
  import PaymentSummary from "../components/itinerary/PaymentSummary";
  import FlightSummary from "../components/itinerary/FlightSummary";
  import PassengerSummary from "../components/itinerary/PassengersSummary";
  import AndesFooter from "../components/AndesFooter";
  import PaymentPending from "../components/itinerary/PaymentPending";
  import ExtrasList from "../components/itinerary/ExtrasList";
  import { getBooking, getChangeOptions, getRefundOptions, getAvailableExtras } from '@/api/api';
  import { bookingHasCharterFlight } from '@/utils/utils';

  const EXTRA_CATEGORIES = {
    BAGGAGE: true,
    CABIN: true,
    UPGRADE: true,
    CHECKIN: true,
  };
  const EXTRA_GROUPS = {
    baggage: true,
    cabin: true,
    upgrade: true,
    checkin: true,
  };

  export default {
    components: {
      PaymentPending,
      AndesFooter,
      PassengerSummary,
      FlightSummary,
      PaymentSummary,
      LoadingModal,
      AndesHeader,
      ExtrasList
    },
    name: 'itinerary-page',
    data: function () {
      return {
        changeOptions: null,
        refundOptions: null,
        extrasCatalog: [],
      };
    },
    computed: {
      ...mapState(['booking', 'querySearch', 'loading', 'lastName']),
      canChangeFlight: function () {
        if (!this.changeOptions || !this.changeOptions.Enabled || !this.changeOptions.Allowed) {
          return false;
        }
        if (this.pendingChange) return true;
        return (this.changeOptions.Flights || []).some((f) => f.Allowed);
      },
      canRequestRefund: function () {
        if (!this.refundOptions || !this.refundOptions.Enabled) return false;
        return (this.refundOptions.Flights || []).some((f) => f.Allowed);
      },
      pendingChange: function () {
        let change = this.changeOptions && this.changeOptions.Change;
        return change && change.IsOpen ? change : null;
      },
      failedChange: function () {
        let change = this.changeOptions && this.changeOptions.Change;
        return change && change.StatusName === 'FAILED' ? change : null;
      },
      hasPaymentError: function () {
        if (!_.isArray(this.booking.Payments)) {
          return false;
        }
        for (var p of this.booking.Payments) {
          if (p.AuthorizationStatus != 4 && !_.isEmpty(p.MercadoPagoPayment) && p.MercadoPagoPayment.Status == 'approved') {
            return true;
          }
        }
        return false;
      },
      hasCharterFlight: function () {
        return bookingHasCharterFlight(this.booking);
      },
      hasExtras: function () {
        if (!this.booking || !this.booking.Passengers) return false;
        for (let pax of this.booking.Passengers) {
          for (let seg of pax.Segments || []) {
            for (let fee of seg.Fees || []) {
              if (this.isWebExtraCode(fee.SSRCode || fee.FeeCode)) return true;
            }
            for (let leg of seg.Legs || []) {
              for (let ssr of leg.SSRs || []) {
                if (ssr.SSR && EXTRA_CATEGORIES[ssr.SSR.Category]) return true;
                if (this.isWebExtraCode(ssr.SSRCode || ssr.FeeCode)) return true;
              }
            }
          }
        }
        return false;
      },
      bookingLastName: function () {
        if (this.lastName) return this.lastName;
        if (this.booking && this.booking.Passengers && this.booking.Passengers[0]) {
          return this.booking.Passengers[0].LastName;
        }
        return null;
      },
    },
    methods: {
      isWebExtraCode: function (code) {
        if (!code) return false;
        let item = _.find(this.extrasCatalog, (extra) => extra.SSRCode === code || extra.FeeCode === code);
        return !!(item && (EXTRA_CATEGORIES[item.Category] || EXTRA_GROUPS[item.Group]));
      },
      getWrongPayment: function () {
        if (!_.isArray(this.booking.Payments)) {
          return null;
        }
        for (var p of this.booking.Payments) {
          if (p.AuthorizationStatus != 4 && !_.isEmpty(p.MercadoPagoPayment) && p.MercadoPagoPayment.Status == 'approved') {
            return p;
          }
        }
        return null;
      },
      ensureBookingSession: function (done) {
        if (!this.booking.RecordLocator || !this.bookingLastName) {
          done(false);
          return;
        }
        this.$store.commit('loading', true);
        getBooking({
          rl: this.booking.RecordLocator,
          ln: this.bookingLastName,
        }, (result) => {
          this.$store.commit('loading', false);
          if (result && result.BookingID) {
            this.$store.dispatch('updateBooking', result);
            done(true);
            return;
          }
          alert((result && result.error) || this.$t('No se pudo abrir la reserva para agregar servicios.'));
          done(false);
        });
      },
      goAddExtras: function () {
        this.ensureBookingSession((ok) => {
          if (!ok) return;
          this.$store.commit('ancillaryFromItinerary', true);
          this.$store.commit('afterPaymentRoute', 'itinerary');
          this.$router.push('extras');
        });
      },
      goBuySeat: function () {
        this.ensureBookingSession((ok) => {
          if (!ok) return;
          this.$store.commit('ancillaryFromItinerary', true);
          this.$store.commit('afterPaymentRoute', 'itinerary');
          this.$router.push('seats');
        });
      },
      goChangeFlight: function () {
        this.ensureBookingSession((ok) => {
          if (!ok) return;
          this.$router.push('change');
        });
      },
      goRefund: function () {
        this.ensureBookingSession((ok) => {
          if (!ok) return;
          this.$router.push('refund');
        });
      },
      loadChangeOptions: function () {
        if (!this.booking.BookingID) return;
        getChangeOptions(this.booking.BookingID, (result) => {
          this.changeOptions = result;
        }, () => {
          this.changeOptions = null;
        });
      },
      loadRefundOptions: function () {
        if (!this.booking.BookingID) return;
        getRefundOptions(this.booking.BookingID, (result) => {
          this.refundOptions = result;
        }, () => {
          this.refundOptions = null;
        });
      },
    },
    mounted() {
      this.$store.commit('ancillaryFromItinerary', false);
      this.$store.commit('loading', false);
      if (_.isEmpty(this.booking)) {
        this.$router.replace('/');
        return;
      }
      let bookingId = this.booking.BookingID;
      getAvailableExtras((result) => {
        this.extrasCatalog = Array.isArray(result) ? result : [];
      }, bookingId);
      if (this.booking.RecordLocator && this.bookingLastName) {
        getBooking({
          rl: this.booking.RecordLocator,
          ln: this.bookingLastName,
        }, (result) => {
          if (result && result.BookingID) {
            this.$store.dispatch('updateBooking', result);
            getAvailableExtras((extras) => {
              this.extrasCatalog = Array.isArray(extras) ? extras : [];
            }, result.BookingID);
          }
          this.loadChangeOptions();
          this.loadRefundOptions();
        });
        return;
      }
      this.loadChangeOptions();
      this.loadRefundOptions();
    }
  }
</script>

<style scoped>
.itin-ancillary-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.itin-ancillary-actions .btn {
  min-width: 160px;
}
</style>

